import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './combined.reducer';
import normalizeMiddleware from './middlewares/normalizer';
import createDepracatedTokenMiddleware from './middlewares/depracatedToken';
import trackingMiddleware from './middlewares/tracking';
import homeSaga from './home/Home.saga';
import appSaga from './App.saga';
import settingsSaga from './settings/Settings.saga';
import messagesSaga from './messages/Messages.saga';
import popupSaga from './popups/Popup.saga';

import formSaga from './form/Form.saga';
import offerSaga from './form/components/Offer/offer.saga';
import toastsSaga from './toasts/toasts.saga';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(
            createDepracatedTokenMiddleware(),
            sagaMiddleware,
            normalizeMiddleware,
            trackingMiddleware
        )
    )
);
sagaMiddleware.run(toastsSaga);
sagaMiddleware.run(formSaga);
sagaMiddleware.run(offerSaga);
sagaMiddleware.run(homeSaga);
sagaMiddleware.run(appSaga);
sagaMiddleware.run(settingsSaga);
sagaMiddleware.run(messagesSaga);
sagaMiddleware.run(popupSaga);

export default store;
